import React from 'react'

const LosAngeles = () => {
  return (
    <div>LosAngeles</div>
  )
}

export default LosAngeles